import { formatDate } from "@fullcalendar/react";
import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";

export default function ParticipantList({ eventId, back }) {
  const [participants, setParticipants] = useState([
    {
      name: "A",
      surname: "A",
      phone: "0874923",
    },
    {
      name: "b",
      surname: "A",
      phone: "345325",
    },
    {
      name: "c",
      surname: "A",
      phone: "325235",
    },
    {
      name: "d",
      surname: "A",
      phone: "34566567",
    },
    {
      name: "A",
      surname: "A",
      phone: "0874923",
    },
    {
      name: "b",
      surname: "A",
      phone: "345325",
    },
    {
      name: "c",
      surname: "A",
      phone: "325235",
    },
    {
      name: "d",
      surname: "A",
      phone: "34566567",
    },

  ]);
  const columns = [
    { dataField: "name", text: "Name" },
    { dataField: "surname", text: "Surname" },
    { dataField: "phone", text: "Phone" },
  ];
  return (
    <div
      style={{
        position: "absolute",
        width: "calc(100% - 320px)",
        height: "calc(100% - 20px)",
        backgroundColor: "#fff",
        zIndex: 1500,
        padding: "20px",
        marginLeft: 300,
        overflow: "auto",
      }}
    >
      <button type="button" className="btn-link padding-0" onClick={back}>
        <i className="fa fa-angle-left" /> Back
      </button>
      <h3>Participants</h3>
      <BootstrapTable keyField="name" data={participants} columns={columns} />
    </div>
  );
}
